import { render, staticRenderFns } from "./EditPackageComponent.vue?vue&type=template&id=3eda1797&"
import script from "./EditPackageComponent.vue?vue&type=script&lang=js&"
export * from "./EditPackageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports